// frontend/src/pages/ExpenseList.tsx
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
const list = () => fetch("/api/v1/hr.expense.sheet", { headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } }).then(r => r.json()).then((r: any) => r.ok ? r.data : []);
const act = (id: number, a: string) => fetch(`/api/v1/hr.expense.sheet/${id}/${a}`, { method: "POST", headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } });
const stateColors: Record<string, string> = { draft:"bg-gray-100 text-gray-700", submitted:"bg-blue-100 text-blue-700", approved:"bg-green-100 text-green-700", paid:"bg-teal-100 text-teal-700", cancel:"bg-red-100 text-red-700" };
export default function ExpenseList() {
  const qc = useQueryClient();
  const { data: sheets } = useQuery({ queryKey: ["expenses"], queryFn: list });
  const cu = (fn: any) => useMutation({ mutationFn: fn, onSuccess: () => qc.invalidateQueries({ queryKey: ["expenses"] }) });
  const submitMut = cu((id: number) => act(id, "submit"));
  const approveMut = cu((id: number) => act(id, "approve"));
  const payMut = cu((id: number) => act(id, "pay"));
  return <div>
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-2xl font-bold">Expense Reports</h1>
      <Link to="/expenses/new" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">+ New Report</Link>
    </div>
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 border-b">
          <tr><th className="text-left px-4 py-3 font-medium text-gray-600">Name</th><th className="text-center px-4 py-3 font-medium text-gray-600">State</th><th className="text-right px-4 py-3 font-medium text-gray-600">Amount</th><th className="text-right px-4 py-3 font-medium text-gray-600">Actions</th></tr>
        </thead>
        <tbody className="divide-y">
          {sheets?.map((s: any) => (
            <tr key={s.id} className="hover:bg-gray-50">
              <td className="px-4 py-3 font-medium">{s.name}</td>
              <td className="px-4 py-3 text-center"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${stateColors[s.state] ?? ""}`}>{s.state}</span></td>
              <td className="px-4 py-3 text-right">${(s.total_amount ?? 0).toFixed(2)}</td>
              <td className="px-4 py-3 text-right space-x-2">
                {s.state === "draft" && <button onClick={() => submitMut.mutate(s.id)} className="text-blue-600 hover:text-blue-800 text-xs font-medium">Submit</button>}
                {s.state === "submitted" && <button onClick={() => approveMut.mutate(s.id)} className="text-green-600 hover:text-green-800 text-xs font-medium">Approve</button>}
                {s.state === "approved" && <button onClick={() => payMut.mutate(s.id)} className="text-teal-600 hover:text-teal-800 text-xs font-medium">Mark Paid</button>}
              </td>
            </tr>
          ))}
          {(!sheets || sheets.length === 0) && <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-400">No expense reports</td></tr>}
        </tbody>
      </table>
    </div>
  </div>;
}
